import { Cell, flexRender } from "@tanstack/react-table";
import { TableCell } from "@/components/ui/table";
import { memo, useMemo } from "react";
import { cn } from "@/lib/utils";

interface ProjectSchedulesTableCellProps<TData extends { id: string }> {
  cell: Cell<TData, unknown>;
}

const ProjectSchedulesTableCellComponent = <TData extends { id: string }>({
  cell,
}: ProjectSchedulesTableCellProps<TData>) => {
  const columnSize = cell.column.columnDef.size;
  const className = cell.column.columnDef.meta?.className;

  const style = useMemo(
    () => ({ width: columnSize ? `${columnSize}px` : "auto" }),
    [columnSize],
  );

  return (
    <TableCell
      key={cell.id}
      data-testid={cell.column.id}
      className={cn(
        className,
        "flex justify-center items-center border-t-0 p-0 h-[33px]",
      )}
      style={style}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </TableCell>
  );
};

export const ProjectSchedulesTableCell = memo(
  ProjectSchedulesTableCellComponent,
) as <TData extends { id: string }>(
  props: ProjectSchedulesTableCellProps<TData>,
) => JSX.Element;
